// Flavor block — coloured dot sync.
// Dropdowns are now native <select>s rendered by Liquid from product variants
// (no Simple Bundles widget to wrestle with). All we do here is: when a select
// changes, look up the selected flavor's color in the data-flavor-colors map
// and update the .__dot's bg/border to that color.

(function () {
  function init(root) {
    if (!root || root.dataset.flavorInit === '1') return;
    root.dataset.flavorInit = '1';

    var colorMap = {};
    try { colorMap = JSON.parse(root.getAttribute('data-flavor-colors') || '{}'); } catch (e) {}

    function syncDot(wrap) {
      var select = wrap.querySelector('[data-flavor-select]');
      var dot    = wrap.querySelector('[data-flavor-dot]');
      if (!select || !dot) return;
      var color = (select.value && colorMap[select.value]) || '';
      if (color) {
        dot.style.background = color;
        dot.style.borderColor = color;
      } else {
        dot.style.background = 'transparent';
        dot.style.borderColor = '#B9B9B9';
      }
    }

    root.querySelectorAll('[data-flavor-wrap]').forEach(function (wrap) {
      syncDot(wrap);
      var select = wrap.querySelector('[data-flavor-select]');
      if (select) select.addEventListener('change', function () { syncDot(wrap); });
    });
  }

  function bootAll() {
    document.querySelectorAll('[data-flavor-block]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }
  document.addEventListener('shopify:section:load', bootAll);
  document.addEventListener('shopify:block:load', bootAll);
})();
